export const staticSurvey = {
    "message": "success",
    "data": {
        "_id": "67f0024bd18d86f810a5329d",
        "channelId": "2007196394",
        "channelName": "JOY CLUB",
        "channelType": "LINE",
        "status": "publish",
        "active": true,
        "surveyMasterId": "67f0024bd18d86f810a53295",
        "general": {
            "name": "CRM Register Channel : JOY CLUB",
            "termAndCondition": "",
            "termAndConditionType": "text",
            "termAndConditionFileUrl": "",
            "rewrite": false,
            "edit": false,
            "detail": "",
            "quota": 1,
            "quotaActive": false,
            "pdpaActive": false,
            "pdpaId": "",
            "showTermFirst": false
        },
        "question": {
            "pages": [
                {
                    "title": "",
                    "order": 1,
                    "jumpCondition": "Next Page",
                    "conditionRequired": false,
                    "questions": [
                        {
                            "type": "fullname",
                            "order": 1,
                            "required": true,
                            "title": "ชื่อ-นามสกุล|Full Name",
                            "description": "โปรดระบุชื่อ-นามสกุลของท่านให้ตรงตามบัตรประชาชน/หนังสือเดินทาง|Please state your full name as it appears on your ID card/Passport.",
                            "textBoxSize": "single",
                            "customValidationEnable": true,
                            "customValidationRegex": "^[a-zA-Zก-๙]{2,}(?:\\s[a-zA-Zก-๙]{1,}){1,}$",
                            "customValidationErrorMessage": "ชื่อ-นามสกุลของท่านไม่ถูกต้อง กรุณาระบุใหม่|Your first name and last name are incorrect. Please try again.",
                            "choices": [],
                            "conditions": {
                                "data": []
                            },
                            "_id": "65d4c78ac5bf3695e08b2abe"
                        },
                        {
                            "type": "radio",
                            "order": 2,
                            "required": true,
                            "title": "รูปแบบเอกสาร|Document Format",
                            "titleImageUrl": "",
                            "description": "",
                            "choices": [
                                {
                                    "key": "0",
                                    "value": "บัตรประชาชน|ID Card",
                                    "imageUrl": ""
                                },
                                {
                                    "key": "1",
                                    "value": "หนังสือเดินทาง|Passport",
                                    "imageUrl": ""
                                }
                            ],
                            "conditions": {
                                "required": false,
                                "data": [
                                    {
                                        "key": "0",
                                        "value": "บัตรประชาชน|ID Card",
                                        "condition": ""
                                    },
                                    {
                                        "key": "1",
                                        "value": "หนังสือเดินทาง|Passport",
                                        "condition": ""
                                    }
                                ]
                            },
                            "twoColumnFormatChoices": false,
                            "randomChoiceOrder": false,
                            "isMatchingOrderChannelType": false,
                            "crmProfileKey": "identityType",
                            "_id": "67e16725049ed70ed8573e5c"
                        },
                        {
                            "type": "text",
                            "order": 3,
                            "required": true,
                            "title": "เลขบัตรประจำตัวประชาชน/เลขที่หนังสือเดินทาง|ID Card Number/Passport Number",
                            "titleImageUrl": "",
                            "description": "โปรดระบุเลขของท่านให้ตรงตามเลขบัตรประจำตัวประชาชน/เลขที่หนังสือเดินทาง|Please enter your number exactly as it appears on your ID card or passport.",
                            "textBoxSize": "single",
                            "maxCharacters": 13,
                            "customValidationEnable": true,
                            "customValidationRegex": "^\\d{13}$|^[A-Z0-9]{5,20}$",
                            "customValidationErrorMessage": "เลขบัตรประชาชน/เลขที่หนังสือเดินทางของท่านไม่ถูกต้อง กรุณากรอกใหม่|Your ID card number or passport number is incorrect. Please try again.",
                            "choices": [],
                            "conditions": {
                                "required": false,
                                "data": [
                                    {
                                        "key": "0",
                                        "value": "Blank",
                                        "condition": ""
                                    },
                                    {
                                        "key": "1",
                                        "value": "Not blank",
                                        "condition": ""
                                    }
                                ]
                            },
                            "isMatchingOrderNumer": false,
                            "crmProfileKey": "identityValue",
                            "_id": "67e16725049ed70ed8573e5d"
                        },
                        {
                            "type": "gender",
                            "order": 4,
                            "required": true,
                            "title": "เพศ|Gender",
                            "description": "โปรดระบุเพศของท่าน|Please specify your gender",
                            "choices": [
                                {
                                    "key": "0",
                                    "value": "ชาย|Male"
                                },
                                {
                                    "key": "1",
                                    "value": "หญิง|Female"
                                },
                                {
                                    "key": "2",
                                    "value": "LGBTQ+|LGBTQ+"
                                },
                                {
                                    "key": "3",
                                    "value": "ไม่ระบุ|Not specified"
                                }
                            ],
                            "conditions": {
                                "data": []
                            },
                            "_id": "65d4c78ac5bf3695e08b2ab9"
                        },
                        {
                            "type": "birthdate",
                            "order": 5,
                            "required": true,
                            "title": "วันเกิด (วัน/เดือน/ปี)|Date of birth (Day/Month/Year)",
                            "format": "dd/MM/yyyy",
                            "description": "โปรดระบุวันเกิดของท่านให้ตรงตามบัตรประชาชน|Please specify your date of birth",
                            "choices": [],
                            "conditions": {
                                "data": []
                            },
                            "_id": "65d4c78ac5bf3695e08b2abb"
                        },
                        {
                            "type": "address",
                            "order": 6,
                            "required": true,
                            "title": "ที่อยู่|Address",
                            "description": "โปรดระบุที่อยู่ของท่าน|Please specify address",
                            "choices": [],
                            "conditions": {
                                "data": []
                            },
                            "_id": "65d4c78ac5bf3695e08b2aba"
                        },
                        {
                            "type": "email",
                            "order": 7,
                            "required": true,
                            "title": "อีเมล|E-mail Address",
                            "description": "โปรดระบุ E-mail Address ของท่าน|Please specify your E-mail Address",
                            "textBoxSize": "single",
                            "choices": [],
                            "conditions": {
                                "data": []
                            },
                            "_id": "65d4c78ac5bf3695e08b2abc"
                        },
                        {
                            "type": "dropdown",
                            "order": 8,
                            "required": true,
                            "title": "ศิลปินที่ชื่นชอบ|Favorite Artist",
                            "titleImageUrl": "",
                            "description": "กรุณาเลือกสูงสุด 3 ลำดับ|Please choose up to 3 answers.",
                            "textBoxSize": null,
                            "maxCharacters": null,
                            "customValidationEnable": false,
                            "customValidationRegex": "",
                            "customValidationErrorMessage": "",
                            "choices": [
                                {
                                    "key": "KANGTA",
                                    "value": "KANGTA"
                                },
                                {
                                    "key": "BoA",
                                    "value": "BoA"
                                },
                                {
                                    "key": "TVXQ!",
                                    "value": "TVXQ!"
                                },
                                {
                                    "key": "SUPER JUNIOR",
                                    "value": "SUPER JUNIOR"
                                },
                                {
                                    "key": "Girls’ Generation",
                                    "value": "Girls’ Generation"
                                },
                                {
                                    "key": "SHINee",
                                    "value": "SHINee"
                                },
                                {
                                    "key": "EXO",
                                    "value": "EXO"
                                },
                                {
                                    "key": "Red Velvet",
                                    "value": "Red Velvet"
                                },
                                {
                                    "key": "NCT",
                                    "value": "NCT"
                                },
                                {
                                    "key": "NCT 127",
                                    "value": "NCT 127"
                                },
                                {
                                    "key": "NCT DREAM",
                                    "value": "NCT DREAM"
                                },
                                {
                                    "key": "WayV",
                                    "value": "WayV"
                                },
                                {
                                    "key": "aespa",
                                    "value": "aespa"
                                },
                                {
                                    "key": "RIIZE",
                                    "value": "RIIZE"
                                },
                                {
                                    "key": "NCT WISH",
                                    "value": "NCT WISH"
                                },
                                {
                                    "key": "LUCAS",
                                    "value": "LUCAS"
                                },
                                {
                                    "key": "nævis",
                                    "value": "nævis"
                                },
                                {
                                    "key": "Hearts2Hearts",
                                    "value": "Hearts2Hearts"
                                },
                                 {
                                    "key": "ZEROBASEONE",
                                    "value": "ZEROBASEONE"
                                },
                                {
                                    "key": "none",
                                    "value": "none"
                                },
                                {
                                    "key": "other",
                                    "value": ""
                                }
                            ],
                            "conditions": {
                                "data": []
                            },
                            "selectChoice": "multi",
                            "selectionRuleEnable": true,
                            "selectionRuleMin": 1,
                            "selectionRuleMax": 3,
                            "crmProfileKey": "favorite",
                            "_id": "67e0e640c836b7fb6fa78454"
                        }
                    ]
                }
            ]
        },
        "onCompletion": {
            "message": "บันทึกข้อมูลลงทะเบียนเรียบร้อยแล้ว|Your registration information has been successfully saved",
            "imageUrl": "",
            "imageRedirectLink": "",
            "sharingIconEnable": false,
            "buttonEnable": false,
            "buttonLabel": "",
            "buttonLink": "",
            "backgroundImageUrl": "",
            "backgroundDisplayMode": "actual",
            "backgroundRedirectLinkEnable": false,
            "backgroundRedirectLink": "",
            "redirectUrl": "https://liff.line.me/2007308145-GLxVKlDb?page=dashboard&shop=UzIwMjUwNDIyWEROVUQ=&liffId=2007308145-GLxVKlDb"
        },
        "revisitAfterCompletion": {
            "message": "คุณเคยทำแบบสอบถามนี้แล้ว|You have already completed this questionnaire",
            "imageUrl": "",
            "imageRedirectLink": "",
            "sharingIconEnable": false,
            "buttonEnable": false,
            "buttonLabel": "",
            "buttonLink": "",
            "backgroundImageUrl": "",
            "backgroundDisplayMode": "actual",
            "backgroundRedirectLinkEnable": false,
            "backgroundRedirectLink": ""
        },
        "basicDesign": {
            "color": {
                "text": "#263147",
                "background": "#FFFFFF",
                "choicesBackground": "#7B9450",
                "buttonLabel": "#FFFFFF",
                "buttonBackground": "#7D81E3",
                "progressBar": "#15BD66"
            },
            "showProgressBar": false,
            "headerImageUrl": "",
            "backgroundImageUrl": "",
            "backgroundDisplayMode": "actual"
        },
        "publicType": "",
        "surveyStartDate": "",
        "surveyEndDate": "",
        "registerCrmChannelId": "2007196394",
        "createdAt": "2025-04-04T16:01:15.137Z",
        "updatedAt": "2025-04-11T03:31:25.437Z",
        "liffUrl": "https://liff.line.me/2007308145-QAJVLZWM/x/eFOH0m",
        "shortUrl": "/x/eFOH0m",
        "shareUrl": "/survey/67f0024bd18d86f810a5329d",
        "shortId": "DDcfUARKH"
    }
}